import { useState } from "react";
// import { Fragment, useMemo } from "react";
import {
  Popover,
  // Typography,
  ButtonBase,
  useTheme,
  IconButton,
  // Paper,
  Chip,
  // Avatar,
} from "@mui/material";
// import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
// import CircleIcon from "@mui/icons-material/Circle";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { PopperInner } from "./AppointmentEventItemStyles";
import { format } from "date-fns";
import { HOUR_FORMAT } from "Common/constant";
import Stack from "@mui/material/Stack";
import { SHOW_AVAILABILITIES_COLOR } from "Common/constant";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import { NON_AVAILABLE_CELL_COLOR } from "Common/constant";

const ShowAvailabilities = ({ event, dayAvailabilities }) => {
  const [ancholElRef, setAnchorElRef] = useState(null);
  const hFormat = HOUR_FORMAT === "12" ? "hh:mm a" : "HH:mm";
  const theme = useTheme();

  const triggerShowAvail = (el) => {
    // if (!el && deleteConfirm) {
    //   setDeleteConfirm(false);
    // }
    setAnchorElRef(el || null);
  };

  return (
    <>
      <ButtonBase
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          triggerShowAvail(e.currentTarget);
        }}
        style={{
          width: "10%",
          height: "100%",
          background: SHOW_AVAILABILITIES_COLOR,
        }}
      >
        <div
          style={{
            height: "100%",
          }}
        ></div>
      </ButtonBase>
      <Popover
        open={Boolean(ancholElRef)}
        anchorEl={ancholElRef}
        onClose={() => {
          triggerShowAvail();
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <PopperInner style={{ width: "200px" }}>
          <div
            style={{
              background: SHOW_AVAILABILITIES_COLOR,
              alignItems: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: NON_AVAILABLE_CELL_COLOR,
              // background: "#74B84B",
              // textAlign: "right",
            }}
          >
            <span>Available Times</span>
            <IconButton
              size="small"
              onClick={() => {
                triggerShowAvail();
              }}
            >
              <ClearRoundedIcon sx={{ color: "#FFFFFF" }} />
            </IconButton>
          </div>
          <div>
            {/* <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              variant="dot"
            ></StyledBadge> */}

            {/* <Stack spacing={2} direction="row"> */}

            {/* </Stack> */}
            <Stack spacing={2}>
              {/* <div
              style={{
                // paddingLeft: 12,
                textAlign: "center",
                // border: "1px solid #ECE4E4",
                // borderRadius: "4px",
                // background: "#ECE4E4",
              }}
            > */}
              {dayAvailabilities.map((item, index) => {
                return (
                  <Chip
                    key={index}
                    style={{
                      border: "1px solid #ACACE1",
                      // background: "#ACACE1",
                      // color: "#FFFFFF",
                    }}
                    // color="success"
                    label={`${format(new Date(item.start), hFormat)} - ${format(
                      item.end,
                      hFormat
                    )}`}
                    variant="outlined"
                  />
                );
              })}
            </Stack>
          </div>
        </PopperInner>
      </Popover>
    </>
  );
};

export default ShowAvailabilities;
